var moduleMap = {
	"./App": () => {
		return Promise.all(/* __federation_expose_App */[__webpack_require__.e(8791), __webpack_require__.e(6862), __webpack_require__.e(3915), __webpack_require__.e(1083), __webpack_require__.e(2445), __webpack_require__.e(8429), __webpack_require__.e(3243), __webpack_require__.e(4319), __webpack_require__.e(289)]).then(() => (() => ((__webpack_require__(59242)))));
	},
	"./BidTemplates": () => {
		return Promise.all(/* __federation_expose_BidTemplates */[__webpack_require__.e(7113), __webpack_require__.e(6479), __webpack_require__.e(5970), __webpack_require__.e(3431), __webpack_require__.e(8791), __webpack_require__.e(6862), __webpack_require__.e(3941), __webpack_require__.e(1083), __webpack_require__.e(2445), __webpack_require__.e(8429), __webpack_require__.e(3243), __webpack_require__.e(9546)]).then(() => (() => ((__webpack_require__(17677)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope, remoteEntryInitOptions) => {
	return __webpack_require__.federation.bundlerRuntime.initContainerEntry({	webpackRequire: __webpack_require__,
		shareScope: shareScope,
		initScope: initScope,
		remoteEntryInitOptions: remoteEntryInitOptions,
		shareScopeKey: "default"
	})
};


// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});